import { Table, Body, Head, Row, Th, Td, Paginator, NoDataComponent } from "../Tables/Table"
import { JournalResponse } from "../../interfaces/Journal/types";
import { FC } from "react"
import { utcToDateTime, formatDateTime } from '../../helpers/dateFormatter';
import { BoxWrapper } from "../Wrappers/Wrappers";
import { LoadingTableCell } from "../Loading/Loading";
import { DateRangeEnum } from "../../interfaces/DatePicker/types";
import { JournalRequestParams } from "../../interfaces/Journal/types";
import { DateRangePicker, selectedDateRangeRest } from "../Pickers/dataRange";
import { SmFormCkeckBox } from "../Form/FormInput";
import { TablePaginationSelector } from "../Pickers/tableFilters";
import { RestApiState } from "../../interfaces/Rest/types";
import { SubmitButton } from "../Buttons/buttons";
import { Text } from "../units/Text";
import { useState } from "react";
import Alert from "../units/Alerts";
import { FlexWrapper } from "../Wrappers/Wrappers";
import { JournalResults } from "../../interfaces/Journal/types";
import { JournalSectionViewProps } from "../../interfaces/AccumulatorView/types";
import { dateRangeValues } from "../Pickers/v2/datePicker";
// const tableNoData = 'Нет данных'


interface AcbRangedTableProps {
    data: JournalResponse | null;
    currentPage: number;
    itemsPerPage: number;
    params: JournalRequestParams;
    setter: (value: any) => void; // Needed for pagination
    orderSetter?: (value: string) => void;
}


export const Journal:FC<AcbRangedTableProps> = ({ data, currentPage, itemsPerPage, params, setter }):JSX.Element => {
    const [journal, setJournal] = useState<JournalResults | undefined>(undefined)
    const [alertState, setAlertState] = useState<boolean>(false)

    return (
        <>
    <BoxWrapper p="p0" bg="bg-primary" className="x-scroll relative full-width" r="r15" style={{zIndex:100}}>
            <Table className="table-fixed">
                <Head>
                    <Row>
                        <Th className="align-center table-align-left col-175">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Дата
                            </BoxWrapper>
                        </Th>
                        <Th className="col-150">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Описание
                            </BoxWrapper>
                        </Th>
                        <Th className="col-100">
                            <BoxWrapper className="flex align-center flex-end" p="p0">
                                SOC
                            </BoxWrapper>
                        </Th>
                        <Th className="col-125">
                            <BoxWrapper className="flex align-center flex-end" p="p0">
                                Напряжение
                            </BoxWrapper>
                        </Th>
                        <Th className="col-125">
                            <BoxWrapper className="flex align-center flex-end" p="p0">
                                Ток
                            </BoxWrapper>
                        </Th>
                        <Th className="col-125">
                            <BoxWrapper className="flex align-center flex-end" p="p0">
                                Cell max
                            </BoxWrapper>
                        </Th>
                        <Th className="col-125">
                            <BoxWrapper className="flex align-center flex-end" p="p0">
                                Cell min
                            </BoxWrapper>
                        </Th>
                        <Th className="col-125">
                            <BoxWrapper className="flex align-center flex-end" p="p0">
                                Темп. max
                            </BoxWrapper>
                        </Th>
                        <Th className="col-125">
                            <BoxWrapper className="flex align-center flex-end" p="p0">
                                Темп.min
                            </BoxWrapper>
                        </Th>
                        <Th className="col-100">
                            <></>
                        </Th>
                    </Row>
                </Head>
                <Body>
                    { data?.results ? (data.results.map((item, index) => (
                        <Row key={index} className="">
                            <Td className="table-align-left">
                                { utcToDateTime(item.Time) }
                            </Td>
                            <Td className="table-align-left">
                                { item.CodeStateDisplay }
                            </Td>
                            <Td className="table-align-right">
                                { item.SOC }
                            </Td>
                            <Td className="table-align-right">
                                { item.Voltage.toFixed(2) }
                            </Td>
                            <Td className="table-align-right">
                                { item.Current.toFixed(2) }
                            </Td>
                            <Td className="table-align-right">
                                { item.CellVoltageMax.toFixed(2) }
                            </Td>
                            <Td className="table-align-right">
                                { item.CellVoltageMin.toFixed(2) }
                            </Td>
                            <Td className="table-align-right">
                                { item.CellTempMax }
                            </Td>
                            <Td className="table-align-right">
                                { item.CellTempMin }
                            </Td>
                            <Td>
                                <Text color="orange" className="flex align-center space-between underline pointer" onClick={(value: any) => { 
                                    setAlertState(true) 
                                    setJournal(item)
                                    }}>
                                    Детали
                                </Text>    
                            </Td>
                        </Row>
                    ))) : (
                        Array.from({ length: itemsPerPage }, (_:any, index:number) => {
                            return (
                                <Row className="" key={index}>
                                    <Td><LoadingTableCell/></Td>
                                </Row>
                            )
                        }) 
                    )
                }
                </Body>
            </Table>
            { data?.results?.length === 0 && <NoDataComponent/> }
            <Paginator
                key={data?.results ? data.results.length + 1 : 0}
                itemsPerPage={itemsPerPage} 
                totalItems={data ? data.count : 1} 
                currentPage={currentPage} 
                setPage={setter}/>
        </BoxWrapper>
{ journal &&
                (
                <Alert alertState={alertState} alertHandler={setAlertState} alertTitle='Журнал' style={{width: '100%', maxWidth: '550px'}}>
                    <Text>Детали журнала</Text>
                    <br />
                    <BoxWrapper style={{maxHeight:'500px', overflowY: 'scroll'}} className="">
                        <FlexWrapper className="narrow-gap journal-records">
                            <Text className="bold" size="xl">Дата</Text>
                            <br />
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                    Дата создания на сервере
                                </Text>
                                <Text>
                                    {formatDateTime(journal.created_at)}
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                    Time (utc)
                                </Text>
                                <Text>
                                    {journal.Time}
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                    Time (+3)
                                </Text>
                                <Text>
                                    { utcToDateTime(journal.Time) }
                                </Text>
                            </FlexWrapper>
                        </FlexWrapper>
                        <br />

                        <FlexWrapper className="narrow-gap journal-records">
                            <Text className="bold" size="xl">Показатели</Text>
                            <br />
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                    SNBattery
                                </Text>
                                <Text>
                                    {journal.SNBattery}
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                record_id
                                </Text>
                                <Text>
                                    {journal.record_id}
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                    TypeMessage
                                </Text>
                                <Text>
                                    {journal.TypeMessage}
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                    CodeState
                                </Text>
                                <Text>
                                    { journal.CodeState }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                    CodeStateDisplay
                                </Text>
                                <Text>
                                    { journal.CodeStateDisplay }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                    SOC
                                </Text>
                                <Text>
                                    { journal.SOC }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                    DOD
                                </Text>
                                <Text>
                                    { journal.DOD }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                    SOH
                                </Text>
                                <Text>
                                    { journal.SOH }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                    Capacity
                                </Text>
                                <Text>
                                    { journal.Capacity }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                    NumFullDischCycles
                                </Text>
                                <Text>
                                    { journal.NumFullDischCycles }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                    NumPartDischCycles
                                </Text>
                                <Text>
                                    { journal.NumPartDischCycles }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                ChargeCoulomb
                                </Text>
                                <Text>
                                    { journal.ChargeCoulomb }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                EnergyCharge
                                </Text>
                                <Text>
                                    { journal.EnergyCharge }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                EnergyDischarge
                                </Text>
                                <Text>
                                    { journal.EnergyDischarge }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                Current
                                </Text>
                                <Text>
                                    { journal.Current }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                Resistance
                                </Text>
                                <Text>
                                    { journal.Resistance }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                CellVoltageMin
                                </Text>
                                <Text>
                                    { journal.CellVoltageMin }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                CVMinNumSlave
                                </Text>
                                <Text>
                                    { journal.CVMinNumSlave }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                CVMinNumber
                                </Text>
                                <Text>
                                    { journal.CVMinNumber }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                CellVoltageMax
                                </Text>
                                <Text>
                                    { journal.CellVoltageMax }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                CVMaxNumSlave
                                </Text>
                                <Text>
                                    { journal.CVMaxNumSlave }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                CVMaxNumber
                                </Text>
                                <Text>
                                    { journal.CVMaxNumber }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                CellTempMin
                                </Text>
                                <Text>
                                    { journal.CellTempMin }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                CTMinNumSlave
                                </Text>
                                <Text>
                                    { journal.CTMinNumSlave }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                CTMinNumber
                                </Text>
                                <Text>
                                    { journal.CTMinNumber }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                CVMaxNumSlave
                                </Text>
                                <Text>
                                    { journal.CVMaxNumSlave }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                CellTempMax
                                </Text>
                                <Text>
                                    { journal.CellTempMax }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                CTMaxNumSlave
                                </Text>
                                <Text>
                                    { journal.CTMaxNumSlave }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                TimeIDEL
                                </Text>
                                <Text>
                                    { journal.TimeIDEL }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                TimeCharge
                                </Text>
                                <Text>
                                    { journal.TimeCharge }
                                </Text>
                            </FlexWrapper>
                            <FlexWrapper className="full-width" justifyContent="space-between">
                                <Text className="bold">
                                TimeDischarge
                                </Text>
                                <Text>
                                    { journal.TimeDischarge }
                                </Text>
                            </FlexWrapper>
                        </FlexWrapper>
                    </BoxWrapper>
                    <br />
                    <FlexWrapper justifyContent='space-between'>
                        <button 
                            type="submit"
                            style={{position:'relative', height: '36px', width: '100%', borderRadius: '5px', outline:'none', border: 'none'}}
                            onClick={(e) => setAlertState(false)}
                            className="pointer bold"
                            >
                            Закрыть
                        </button>
                    </FlexWrapper>
                </Alert>
                )
            }
        </>
    )
}

// Refactor move this into daterange component
export type RangedProps = {
    isOpen: boolean;
    dateRange: DateRangeEnum;
    setDateRangeOpen: (value: boolean) => void;
    setDateRange: (value: DateRangeEnum) => void;
}

interface PaginationProps {
    isOpen: boolean;
    setOpen: (value: boolean) => void;
    setValue: (value: number) => void;
}

interface AcbRangedTableHandlerProps extends AcbRangedTableProps {
    rangeProps: RangedProps
    setJournalParam: (value: any) => void;
    paginationProps: PaginationProps;
    downloadButton: {
        postStatus: RestApiState;
        timeOutId: NodeJS.Timeout | null;
        disabled: boolean;
        action: (e: any) => void
        restSetter: (key: 'requestState' | 'timeOutId', value: any) => void;
    }
}

interface JournalSectionProps {
    serial_number: string;
    props: JournalSectionViewProps;
    setViewProps: (value: any) => void;
    action: (value: any) => void;
}

export const JournalHandler = ({ serial_number, props, setViewProps, action }: JournalSectionProps) => {
    const params = props.params
    const data = props.data


    const setDateRangeOpen = (isOpen: boolean): void => {
        setViewProps(
            (prev : { journalSectionView: { calendar: any; }; })=> (
                {
                    ...prev, journalSectionView : {
                        ...prev.journalSectionView, calendar : {
                            ...prev.journalSectionView.calendar,
                                isOpen : isOpen
                        }
                    }
                }
        ))
    }

    const setDateRange = (dateRange: DateRangeEnum): void => {
        setViewProps(
            (prev : { journalSectionView: { calendar: any; }; }) => (
                {
                    ...prev, journalSectionView : {
                        ...prev.journalSectionView, calendar : {
                            ...prev.journalSectionView.calendar,
                                dateRange: dateRange
                        }
                    }
                }
            )
        )
        setViewProps(
            (prev : { journalSectionView: { params: any; }; }) => (
                {
                    ...prev, journalSectionView : {
                        ...prev.journalSectionView, params : {
                            ...prev.journalSectionView.params,
                            period: selectedDateRangeRest(dateRange),
                            currentPage: 1,
                            offset: 0,  
                        }
                    }
                }
            )
        )
    }


    const setJournalParam = (name: string, value: any): void => {
        setViewProps(
            (prev : { journalSectionView: { params: any } }) => (
                {
                    ...prev, journalSectionView : {
                        ...prev.journalSectionView, params: {
                            ...prev.journalSectionView.params, 
                                [name]: value,
                                currentPage: 1,
                                offset: 0,  
                        }
                    }
                }
            )
        )
    }

    const setFormParam = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const { name, value } = e.target;
        setJournalParam(name, e.target.checked)
    }

    const setRecordParam = (name: string, value: any): void => {
        setViewProps(
            (prev : { journalSectionView: { params: any } }) => (
                {
                    ...prev, journalSectionView : {
                        ...prev.journalSectionView, params: {
                            ...prev.journalSectionView.params, 
                                [name]: value
                        }
                    }
                }
            )
        )
    }

    const setPaginationOpen = (isOpen: boolean) => {
        setViewProps(
            (prev : { journalSectionView: { pagination: any; }; })=> (
                {
                    ...prev, journalSectionView : {
                        ...prev.journalSectionView, pagination : {
                            ...prev.journalSectionView.pagination,
                                isOpen : isOpen
                        }
                    }
                }
        ))
    }

    const DownloadBtnRestSetter = (key: 'requestState' | 'timeOutId', value: any) => {
        setViewProps(
            (prev : { journalSectionView: {download: any}}) => (
                {
                    ...prev, journalSectionView : {
                        ...prev.journalSectionView, download : {
                            ...prev.journalSectionView.download,
                                [key]: value
                        }
                    }
                }
            )
        );
    };

    return (
        <BoxWrapper className="flex flex-column flex-wrap" r="r0" p="p0">
            <BoxWrapper className="flex space-between flex-wrap" r="r0" p="p0">
                <BoxWrapper className="flex narrow-gap align-center" p='p0' style={{zIndex:1000}}>
                    <BoxWrapper style={{width: '250px'}} p="p0">
                        <DateRangePicker
                            isOpen={props.calendar.isOpen}
                            dateRange={props.calendar.dateRange}
                            setDateRangeOpen={setDateRangeOpen} 
                            setDateRange={setDateRange} 
                            options={[
                                DateRangeEnum.Today,
                                DateRangeEnum.Week,
                                DateRangeEnum.Month,
                                DateRangeEnum.Quartal,
                            ]}    
                        />
                    </BoxWrapper>

                    <form onSubmit={action}>
                        <SubmitButton 
                            restState={props.download.requestState}
                            disabled={props.download.btnDisabled}
                            restHandler={{
                                timeOutId: props.download.timeout,
                                setter: DownloadBtnRestSetter
                            }}  
                            borderRadius="15px"
                            p="p1"
                            text="Скачать .XLSX"
                        />
                    </form>
                </BoxWrapper>
                <BoxWrapper className="flex narrow-gap align-center" p='p0'>
                    <SmFormCkeckBox 
                        value={params.isError}
                        label="Ошибки"
                        name={'isError'}
                        valueSetter={setFormParam}
                        required={false}
                    />
                    <SmFormCkeckBox 
                        value={params.isWarning}
                        label="Предупреждения"
                        name={'isWarning'}
                        valueSetter={setFormParam}
                        required={false}
                    />
                    <SmFormCkeckBox 
                        value={params.isMessage}
                        label="Сообщения"
                        name={'isMessage'}
                        valueSetter={setFormParam}
                        required={false}
                    />
                    <SmFormCkeckBox 
                        value={params.isBmsEvent}
                        label="BMS time event"
                        name={'isBmsEvent'}
                        valueSetter={setFormParam}
                        required={false}
                    />
                </BoxWrapper>
                
                <TablePaginationSelector
                    label={params.limit}
                    options={[{value: 10, label: '10'}, {value: 25, label: '25'}, {value: 50, label: '50'}]}
                    selected={params.limit}
                    isOpen={props.pagination.isOpen}
                    setOpen={setPaginationOpen}
                    dataSetter={(value: any) => { setJournalParam('limit', value) }}
                />
            </BoxWrapper>
            {
                (!data) ? (
                    <div>No data</div>
                ) : (
                    <Journal 
                        data={data}
                        currentPage={params.currentPage}
                        itemsPerPage={params.limit}
                        params={params}
                        setter={ ( value: any) => { setRecordParam('currentPage', value) }} // set current page
                    />
                ) 
            }
        </BoxWrapper>
    )

}